import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap";
import { Icon } from "@iconify/vue2";
import VueSlide from "@splidejs/vue-splide";
import "@splidejs/splide/dist/css/themes/splide-default.min.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import InfiniteSlideBar from "vue-infinite-slide-bar";
import ImageCropper from "@/components/ImageCropper.vue";

Vue.component("InfiniteSlideBar", InfiniteSlideBar);
Vue.component("iconify", Icon);
Vue.component("v-select", vSelect);
Vue.component("ImageCropper", ImageCropper);

Vue.use(VueSlide);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
  mounted: () => {
    AOS.init();
  },
}).$mount("#app");
